/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ModalConfirm, SVGIcon } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { IconColumn } from "../../styles";

type Props = {
  resourceName: string;
  handleRemove: () => void;
};

export function ResourceDelete({ resourceName, handleRemove }: Props) {
  const { isOpen, close, open } = useDisclosure(false);

  return (
    <>
      <IconColumn
        onClick={open}
        css={{ cursor: "pointer" }}
        aria-label="remove item"
      >
        <SVGIcon name="trash" />
      </IconColumn>
      <ModalConfirm
        onClose={close}
        isOpen={isOpen}
        confirm={handleRemove}
        actionLabel="Delete"
        contentLabel={`Delete Resource`}
      >
        Are you sure you want to delete resource {resourceName}?
      </ModalConfirm>
    </>
  );
}
